import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import chevronDownWhite from "../../../assets/svgs/icons/chevron-down-white.svg";
import chevronDownBlue from "../../../assets/svgs/icons/chevron-down.svg";
import chevronUpWhite from "../../../assets/svgs/icons/chevron-up-white.svg";
import chevronUpBlue from "../../../assets/svgs/icons/chevron-up.svg";
import planetWhite from "../../../assets/svgs/icons/planet-white.svg";
import planetBlue from "../../../assets/svgs/icons/planet.svg";
import logoTelemontWhite from "../../../assets/svgs/telemont-logo-white.svg";
import logoTelemontBlue from "../../../assets/svgs/telemont-logo.svg";
import TextButton from "../../buttons/text-button";
import Menu from "../../menu";
import MenuItem from "../../menu-item";
import styles from "./styles.module.css";
const Header = () => {

  const pageLocation = useLocation();
  const navigate = useNavigate();
  const [openEmpresa, setOpenEmpresa] = useState<boolean>(false);
  const [openServicos, setOpenServicos] = useState<boolean>(false);
  const [anchorElEmpresa, setAnchorElEmpresa] = useState<HTMLElement | null>(null);
  const [anchorElServicos, setAnchorElServicos] = useState<HTMLElement | null>(null);
  const [openLanguage, setOpenLanguage] = useState<boolean>(false);
  const [anchorElLanguage, setAnchorElLanguage] = useState<HTMLElement | null>(null);
  const [currentLanguage, setCurrentLanguage] = useState<string>('pt');
  const isHome = pageLocation.pathname === "/";
  const chevronUp = isHome ? chevronUpBlue : chevronUpWhite;
  const chevronDown = isHome ? chevronDownBlue : chevronDownWhite;
  const planet = isHome ? planetBlue : planetWhite;
  const logoTelemont = isHome ? logoTelemontBlue : logoTelemontWhite;

  const handleClickMenu = (button: string, event: React.MouseEvent<HTMLElement>) => {
    if (button === "empresa") {
      setOpenEmpresa((prev) => !prev);
      setAnchorElEmpresa(event.currentTarget);
    } else {
      setOpenServicos((prev) => !prev);
      setAnchorElServicos(event.currentTarget);
    }
  };

  const handleClickSubMenu = (menu: string, subMenuPath: string, event: React.MouseEvent<HTMLElement>) => {
    handleClose(menu);
    navigate(subMenuPath);
  }

  const handleClose = (button: string) => {
    if (button === "empresa") {
      setOpenEmpresa((prev) => !prev);
      setAnchorElEmpresa(null);
    } else if (button === "servicos") {
      setOpenServicos((prev) => !prev);
      setAnchorElServicos(null);
    } else if (button === "language") {
      setOpenLanguage((prev) => !prev);
      setAnchorElLanguage(null);
    }
  };

  const handleLanguageClick = (event: React.MouseEvent<HTMLElement>) => {
    setOpenLanguage((prev) => !prev);
    setAnchorElLanguage(event.currentTarget);
  };

  const handleLanguageChange = (lang: string) => {
    setCurrentLanguage(lang);
    handleClose("language");
  };

  return (
    <div style={{ background: isHome ? "var(--primary-white)" : "var(--gradient-blue-background)" }}>
      <div className={styles["header-content"]}>
        <img src={logoTelemont} alt="Logo Telemont" className={styles["logo"]} onClick={() => { navigate("/") }} />
        <div className={styles["header-page-buttons"]}>
          <TextButton sx={{ padding: '12px', color: isHome ? "var(--primary-blue)" : "var(--primary-white)" }}
            onClick={(event) => handleClickMenu("empresa", event)}
            endIcon={openEmpresa ? chevronUp : chevronDown}
          >
            <span style={{ fontFamily: 'Montserrat-Bold', fontSize: "20px", fontWeight: 700}}>A Empresa</span>
          </TextButton>
          <Menu
            anchorEl={anchorElEmpresa}
            open={openEmpresa}
            handleClose={() => handleClose("empresa")}
          >
            <MenuItem onClick={(e) => { handleClickSubMenu("empresa", "/empresa/sobre-nos", e) }}>
              Sobre Nós
            </MenuItem>
            <MenuItem onClick={(e) => { handleClickSubMenu("empresa", "/empresa/pessoas", e) }}>
              Pessoas
            </MenuItem>
            <MenuItem onClick={(e) => { handleClickSubMenu("empresa", "/empresa/docs-politicas", e) }}>
              Políticas
            </MenuItem>
            {/* <MenuItem onClick={(e) => { handleClickSubMenu("empresa", "/empresa/midia", e) }}>
              Mídia
            </MenuItem> */}
          </Menu>

          <TextButton
            onClick={(event) => handleClickMenu("servicos", event)}
            endIcon={openServicos ? chevronUp : chevronDown}
            sx={{ padding: '12px', color: isHome ? "var(--primary-blue)" : "var(--primary-white)" }}
          > 
          <span style={{ fontFamily: 'Montserrat-Bold', fontSize: "20px", fontWeight: 700}}>Serviços</span>
          </TextButton>
          <Menu
            anchorEl={anchorElServicos}
            open={openServicos}
            handleClose={() => handleClose("servicos")}
          >
            <MenuItem onClick={(e) => { handleClickSubMenu("servicos", "/servicos/telecom", e) }}>
              Telecom
            </MenuItem>
            <MenuItem onClick={(e) => { handleClickSubMenu("servicos", "/servicos/energia", e) }}>
              Energia
            </MenuItem>
          </Menu>
          <TextButton onClick={() => { window.open('https://telemont.gupy.io/', '_blank'); }}
            sx={{ padding: '12px', color: isHome ? "var(--primary-blue)" : "var(--primary-white)" }}
          >
            <span style={{ fontFamily: 'Montserrat-Bold', fontSize: "20px", fontWeight: 700}}>Trabalhe Conosco</span>
          </TextButton>
          <TextButton onClick={(e) => { navigate("/contato") }} sx={{ padding: '12px', color: isHome ? "var(--primary-blue)" : "var(--primary-white)" }}>
            <span style={{ fontFamily: 'Montserrat-Bold', fontSize: "20px", fontWeight: 700}}>Contato</span>
          </TextButton>
        </div>

        <TextButton
          startIcon={planet}
          onClick={handleLanguageClick}
          endIcon={openLanguage ? chevronUp : chevronDown}
          sx={{ padding: '12px', color: isHome ? "var(--primary-blue)" : "var(--primary-white)" }}
        >
          <span style={{ fontFamily: 'Montserrat-Regular', fontSize: "20px", fontWeight: 500}}>{currentLanguage}</span>
        </TextButton>
        <Menu
          anchorEl={anchorElLanguage}
          open={openLanguage}
          handleClose={() => handleClose("language")}
        >
          <MenuItem onClick={() => handleLanguageChange("pt")}>
            Português
          </MenuItem>
          <MenuItem onClick={() => handleLanguageChange("en")}>
            English
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
